export enum FORM_VIEW_INPUT_THEMES {
    DEFAULT = 'default',
    OUTLINED = 'outlined',
}
